import type { UserTenantResponseAPI } from '../types/user';
import TabsSection from './tabs/TabsSection';
import { useMatch, Navigate } from 'react-router-dom';

type Props = { isTenantSelectorOpen: boolean; tenant: UserTenantResponseAPI };

const Tenant = ({ isTenantSelectorOpen, tenant }: Props) => {
    const noTabmatch = useMatch('/:tenantId');

    if (noTabmatch) {
        return <Navigate to={`${tenant.id}/flows`} />;
    }

    return <TabsSection isTenantSelectorOpen={isTenantSelectorOpen} tenant={tenant} />;
};

export default Tenant;
